import { useEffect, useState } from "react";
import { doc, getDoc, setDoc, serverTimestamp, getDocs, collection } from 'firebase/firestore';
import { db } from "../../../firebase";
import { log } from "firebase/firestore/pipelines";

export const QuickAdverts = () => {
    const advert_col_name="adverts"
    const [advertID, setAdvertID]=useState(null)
    const [adverts, setAdverts] = useState({
        advertTitle: '',
        advertDesc: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");


    const handleChange = (e) => {
        const { name, value } = e.target;
        setAdverts((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(advertID);
        console.log(adverts);
        
        
        setLoading(true);
        setError("");
        setSuccessMessage("");
        try {
            await setDoc(doc(db, advert_col_name, advertID), adverts);
            setSuccessMessage("advert infos updated successfully");
            setError(null);
        } catch (error) {
            setError("Failed to update advert infos, Try again later");
            // console.log(error);
            
        }
        finally {
            setLoading(false);
        }
    };
    return (
        <section className="admin-section fade-in">
            <h2>Quick Adverts</h2>
            <form onSubmit={handleSubmit} className="admin-form" >
                <div className="add-products-form-grid">
                    <div className="form-group">
                        <label>select advert</label>
                        <select name="adverts" id="adverts" onChange={(e) =>setAdvertID(e.target.value)} value={advertID} required>
                            <option value="">select advert</option>
                            <option value="advert1">advert 1</option>
                            <option value="advert2">advert 2</option>
                            <option value="advert3">advert 3</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Advert Title</label>
                        <input
                         type="text" 
                         placeholder="Enter advert title" 
                         name="advertTitle"
                         value={adverts.advertTitle}
                          onChange={handleChange}
                          maxLength={40}
                          />
                    </div>
                    {/* <div className="form-group">
                        <label>Upload Image</label>
                        <input type="file" />
                    </div> */}
                </div>
                <div className="form-group form-group--full">
                    <label>Description</label>
                    <textarea
                    name="advertDesc"
                    placeholder="Enter advert description"
                    value={adverts.advertDesc}
                    onChange={handleChange}
                    maxLength={200}
                    required
                    ></textarea>
                </div>
                <button type="submit" className="btn-primary"  disabled={loading}  >
                    {loading ? "posting...." : "Post Advert"}
                </button>
            </form>
            {successMessage && <p className="success-message" style={{ color: 'green' }}>{successMessage}</p>}
            {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}
        </section>
    );
};